import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Erase"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M5.25026 20.25H22.5003V21.75H5.25026V20.25ZM20.5353 7.88249L14.5878 1.94249C14.3065 1.66083 13.9247 1.50256 13.5266 1.50256C13.1285 1.50256 12.7467 1.66083 12.4653 1.94249L1.96532 12.4425C1.68366 12.7238 1.52539 13.1056 1.52539 13.5037C1.52539 13.9019 1.68366 14.2836 1.96532 14.565L5.34782 18H12.5403L20.5353 10.005C20.817 9.72364 20.9753 9.34186 20.9753 8.94374C20.9753 8.54563 20.817 8.16385 20.5353 7.88249ZM11.9178 16.5H6.00027L3.00026 13.5L7.73277 8.76749L13.6803 14.7075L11.9178 16.5ZM14.7379 13.68L8.79789 7.73249L13.5004 2.99999L19.5004 8.94749L14.7379 13.68Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Erase.vue"]]);
